document.addEventListener("turbolinks:load", () => {
  form = $('.simple_form');
  var cocoon = window.form.find('.cocoon.contents');

  const setContentPositions = () => {
    document.querySelectorAll('.nested-fields.contents').forEach((el, index) => {
      const positionInput = el.querySelector("input.content_index_field");
      const positionSpan = el.querySelector("span.content_index");
      if (positionInput) {
        positionInput.value = index + 1;
      }
      if (positionSpan) {
        positionSpan.textContent = index + 1;
      }
    });
  }

  const duplicateContent = (item) => {
    var previous = item.siblings('.nested-fields').not(item).last();

    if (previous.length > 0) {
      previous.find('input, select').each(function() {
        if (this.tagName === 'INPUT' && this.type === 'hidden') { return; }

        var name = $(this).attr('name');
        var value = $(this).val();
        if (value && value != []) {
          if (name.endsWith('[]')) {
            var inputKind = name.match(/\[(\w+)\]\[\]$/)[1];
          } else {
            var inputKind = name.match(/\[(\w+)\]$/)[1];
          }
          var tag = this.tagName.toLowerCase();
          var target = item.find(tag + '[name$="[' + inputKind + ']"], ' + tag + '[name$="[' + inputKind + '][]"]');
          if (target.length) { target.val(value).trigger('change'); }
        }
      });
    }
  }

  cocoon.on('cocoon:after-insert', function(e, item) {
    var triggerButton = document.activeElement;
    setContentPositions();

    if (triggerButton && triggerButton.dataset.action === 'duplicate') {
      duplicateContent(item);
    }
  }).on('cocoon:after-remove', function(e, item) {
    setContentPositions();
  });

  setContentPositions();
});
